import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

axios.defaults.withCredentials = true;
// axios.defaults.headers.common['tsltoken'] = window.sessionStorage.getItem("token");

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    is_weixn: false,//判断是不是微信环境
    screenWidth: '',
    isPc: 1,//1.pc：屏幕大于768；2.pad:大于500;3.手机：小于500
    validToken: false,//判断token是否失效的标志
    userInfo: {},//用户信息
    isDialogVisible: false,//登录弹框
    webInfo: {},
    myCartList: {
      "total": 0,
      "rows": [
        // {
        //   "createBy": null,
        //   "createTime": null,
        //   "updateBy": null,
        //   "updateTime": null,
        //   "remark": null,
        //   "id": 1,
        //   "userId": 1,
        //   "goodsId": 26,
        //   "title": "《台商》月刊208期",
        //   "image": "/profile/upload/2023/06/09/1673597801_20230609180641A001.jpeg,/profile/upload/2023/06/09/1673596953_20230609180741A002.jpeg",
        //   "price": 30
        // },
        // {
        //   "createBy": null,
        //   "createTime": null,
        //   "updateBy": null,
        //   "updateTime": null,
        //   "remark": null,
        //   "id": 2,
        //   "userId": 1,
        //   "goodsId": 27,
        //   "title": "《台商》月刊209期",
        //   "image": "/profile/upload/2023/06/09/1673597801_20230609180641A001.jpeg,/profile/upload/2023/06/09/1673596953_20230609180741A002.jpeg",
        //   "price": 45
        // }
      ],
      "code": 0,
      "msg": null
    },
    searchKeyword: '',
    triggerSearch: false,
  },
  mutations: {
    //判断是不是微信环境
    checkis_weixn(state) {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        state.is_weixn = true;
      } else {
        state.is_weixn = false;
      }
    },
    TRIGGER_SEARCH(state) {
      state.triggerSearch = true;
    },
    RESET_TRIGGER_SEARCH(state) {
      state.triggerSearch = false;
      // state.searchKeyword = '';
    },
    SET_SEARCH_KEYWORD(state, keyword) {
      state.searchKeyword = keyword;
    }
  },
  actions: {
    checkWindowWidth(context) {
      context.state.screenWidth = document.body.clientWidth;
      if(context.state.screenWidth > 768){
        context.state.isPc =1
      }else if(context.state.screenWidth > 500){
        context.state.isPc =2
      }else{
        context.state.isPc =3
      }
      // context.state.isPc = context.state.screenWidth > 768 ? true : false
      window.onresize = () => {
        // console.log(document.body.clientWidth)
        return (() => {
          context.state.screenWidth = document.body.clientWidth;
          if(context.state.screenWidth > 768){
            context.state.isPc =1
          }else if(context.state.screenWidth > 500){
            context.state.isPc =2
          }else{
            context.state.isPc =3
          }
          // context.state.isPc = context.state.screenWidth > 768 ? true : false
        })();
      };
    },
    //验证token是否失效
    async checkToken(context) {
      const { data: res } = await axios.get(`${process.env.BASE_API}/user/info`, { headers: { tsltoken: window.sessionStorage.getItem("token") } });
      console.log('验证token是否失效====', res);
      if (res.code == 500) {
        // 需要登录
        context.state.validToken = false
        return false;
      }
      context.state.validToken = true
      context.state.userInfo = res.data
    },
    //获取网站信息
    async getWebInfo(context) {
      const { data: res } = await axios.get(`${process.env.BASE_API}/webinfo/info`, { headers: { tsltoken: window.sessionStorage.getItem("token") } });
      console.log('获取网站信息====', res);
      if (res.code == 0) {
        context.state.webInfo = res.data
      }
    },
    //获取我的購物車列表
    async getMyCart(context) {
      const { data: res } = await axios.get(`${process.env.BASE_API}/goods/cart`, { headers: { tsltoken: window.sessionStorage.getItem("token") } });
      console.log('获取我的購物車列表====', res);
      if (res.code == 0) {
        context.state.myCartList=res.data
      }
    },
    triggerSearch({ commit }) {
      commit('TRIGGER_SEARCH');
    },
    setSearchKeyword({ commit }, keyword) {
      commit('SET_SEARCH_KEYWORD', keyword);
    },
    resetTriggerSearch({ commit }) {
      commit('RESET_TRIGGER_SEARCH');
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js